var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#E1FFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1253 6C13.4734 8.51372 13.8121 11.0305 14.1695 13.5412C14.3404 14.7475 14.6542 15.8895 15.3193 16.9612C16.497 18.8595 17.5132 20.8557 18.6972 22.751C19.2845 23.6909 18.9862 23.9604 18.0726 24.3278C12.5473 26.5568 6.07735 23.0051 5.13886 17.1755C4.26253 11.7163 7.60627 7.01039 13.1253 6Z",
    fill: "#12A0A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9447 23C19.3251 20.7135 17.7119 18.43 16 16.0119C18.8701 16.0119 21.5428 16.0353 24.2156 16.0003C25.2434 15.9856 24.9984 16.6084 24.9093 17.0762C24.4606 19.5118 23.2452 21.5322 20.9447 23Z",
    fill: "#12A0A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7884 4.00591C20.4648 4.2549 24.274 7.73772 24.9559 12.0031C25.1058 12.9486 24.9089 13.4407 23.8096 13.4851C21.326 13.58 18.8423 13.7667 16.3645 13.989C15.6856 14.0513 15.521 13.8556 15.4916 13.2272C15.3534 10.4736 15.2035 7.7229 15.0066 4.97518C14.9302 3.94663 15.5386 3.98813 15.7884 4.00591ZM18.3632 13.1917C19.9239 13.0879 21.6757 12.9308 23.4305 12.8686C24.3416 12.836 24.4563 12.4833 24.2623 11.6711C23.3658 7.91853 20.4706 5.28344 16.6496 4.71137C15.6944 4.56909 15.5797 4.93071 15.6385 5.73991C15.7649 7.50652 15.8325 9.27906 15.906 11.0486C15.9942 13.2539 15.9883 13.2539 18.3632 13.1917Z",
    fill: "#12A0A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.a32ee98ee06b447c2693472b1bf26c92.svg";
export { ForwardRef as ReactComponent };